import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FrontEndColumn } from '@app/shared/interfaces/front-end-column';
import { BaseProductComponent } from '@product/shared/base-product.component';
import { SelectionType } from '@product/shared/models/Enums.enum';
import { FilterObject, ListPayload } from '@product/shared/models/ListPayload';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { catchError, map, Observable, of, switchMap, tap } from 'rxjs';
import { productColumns } from '@product/shared/product-base-logic';
import { AppConfigService } from '@app/shared/services/app-config.service';
import {
  Channel,
  ChannelMappingData,
} from '@product/shared/models/integration';
import { ChannelService } from '@app/integration/Channel.service';
import { Product } from '@product/shared/models/product';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
@Component({
  selector: 'app-products-table',
  templateUrl: './products-table.component.html',
  styleUrls: ['./products-table.component.less'],
})
export class ProductsTableComponent extends BaseProductComponent implements OnInit {
  checked = false;
  indeterminate = false;
  @Input() products: any[] = [];
  @Input() isLoading: boolean = true;
  @Input() listColumns: FrontEndColumn[] = productColumns;
  @Input() totalCount = 0;
  @Input() savedFilters: { [key: string]: FilterObject } | null = {};
  @Input() containerHeight: number = 0;
  @Input() selectable: boolean = true;
  @Input() withActions: boolean = true;
  @Input() withHeaderFilters: boolean = true;
  @Input() payload: ListPayload = {
    Filters: {},
    IsAscend: false,
    SortBy: 'Id',
    PageIndex: 0,
    PageSize: 10,
    Attributes: [],
  };
  @Input() disableSelectAll = false;
  @Input() singleSelection = false;
  @Input() isChannel: boolean = false;
  @Input() channelId!: number;      
  @Input() integrationId!: number;   
  @Input() clearSelectedProduct:boolean=false;

  @Output() getProducts = new EventEmitter();
  @Output() selectionChange = new EventEmitter();

  // subscribe to this emitter if you don't want to subscribe to
  // the global filter change emitter in the filters service
  @Output() headerFiltersChanged = new EventEmitter();
  selecttionType: SelectionType | undefined;
  savedViewId = 0;
  selectedIds: Set<number> = new Set();
  _setOfSelectedProducts = new Set<Product>();

  @Input() set setOfSelectedProducts(setOfSelectedProducts: Set<Product>) {

    if (setOfSelectedProducts != null) {
      Array.from(setOfSelectedProducts.values()).forEach((x) => {
        this._setOfSelectedProducts.add(x);
        this.selectedIds.add(x.id!);
      });
    }
  }
  
  get setOfSelectedProducts() {
    return this._setOfSelectedProducts;
  }

  setOfSelectedChannels: Set<Channel> = new Set<Channel>();
  selectedRowId = -1;
  selectorObject: { headerChecked: boolean; headerIndeterminate: boolean } = {
    headerChecked: false,
    headerIndeterminate: false,
  };
  baseUrl = '';
  showSync: boolean;
  mediaUrl = '';

  loading = false;

  constructor(
    private injector: Injector,
    private channelsService: ChannelService,
  ) {
    super(injector);
    this.baseUrl = AppConfigService.settings.baseUrl;
    this.mediaUrl = `${AppConfigService.settings.apiUrl}`;
  }



  ngOnChanges(changes: SimpleChanges) {
  if (changes['clearSelectedProduct'] && changes['clearSelectedProduct'].currentValue === true) {
    this.clearSelected();
  }
}

  ngOnInit(): void {

    this.changeRoute();
  }
  saveViewId: number;

  changeRoute(): void {
    //  Load saveViewId from localStorage
    const savedSaveViewId = localStorage.getItem('saveViewId');
    if (savedSaveViewId) {
      this.saveViewId = +savedSaveViewId;
    }

    //  get saveViewId from Route
    this.route.params.subscribe(params => {
      const savedViewId = +params['savedViewId'];
      if (savedViewId) {
        this.saveViewId = savedViewId;
        localStorage.setItem('saveViewId', this.saveViewId.toString());
      }
    });

    // set saveViewId to URL
    if (this.saveViewId) {
      this.router.navigate([`/product/list`, this.saveViewId], { replaceUrl: true });
    }
  }

  filterChange(column: any, $event: any) {
    // this.valueInput = $event ? $event.sku.Value : null; 
    this.selecttionType = undefined;
    this.headerFiltersChanged.emit({ code: column.name, filter: $event });
  }

  clearSelected() {
    this.setOfSelectedProducts.clear();
    this.selectedIds.clear();
    this.selecttionType = undefined;


  }
  firstQueryParamsHandled = false;
  onQueryParamsChange(event: NzTableQueryParams) {
    const sortColumn = event.sort.find((x) => x.value != null);
    const pageIndex = event.pageIndex;
    const pageSize = event.pageSize;

    this.payload.PageIndex = pageIndex - 1;
    this.payload.PageSize = pageSize;

    if (sortColumn) {
      this.payload.SortBy = sortColumn.key as string;
      this.payload.IsAscend = sortColumn.value === 'ascend';
    }

    if (!this.firstQueryParamsHandled) {
      this.firstQueryParamsHandled = true;
      this.getProducts.emit(this.payload);
      return;
    }

    if (sortColumn || event.pageIndex || event.pageSize) {
      this.getProducts.emit(this.payload);
    }
  }

  // onQueryParamsChange(event: NzTableQueryParams) {
  //   console.log('calle');
  //   const sortColumn = event.sort.find((x) => x.value != null);
  //   this.payload.SortBy = sortColumn?.key as string;
  //   this.payload.IsAscend = sortColumn?.value === 'ascend' ? true : false;
  //   this.getProducts.emit(this.payload);
  // }

  listOfSelection = [
    {
      text: 'Select All',
      onSelect: () => {
        if(this.isChannel){
           this.checked = true;
          this.selectAll();
        }else{
  this.selectAllProducts();

        this.checked = true;
        if (this.setOfSelectedProducts.size > 0) {
          this.selectionChange.emit(this.setOfSelectedProducts);
        }
        }
      
      }
    },
    {
      text: 'Select All In Page',
      onSelect: () => {

        this.setOfSelectedProducts = new Set(this.products);
        this.selectedIds = new Set(this.products.map((x) => x.id!));
        this.indeterminate = true;
        this.selectionChange.emit(this.setOfSelectedProducts);
      }
    },
    {
      text: 'Deselect',
      onSelect: () => {
        this.clearSelected();
        this.indeterminate = false;
        this.checked = false;
        this.selectionChange.emit(this.setOfSelectedProducts);
      }
    }
  ];

  //#region Selection
  onAllSelectionChange() {
    switch (this.selecttionType) {
      case SelectionType.SelectAllInPage:
        this.setOfSelectedProducts = new Set(this.products);
        this.selectedIds = new Set(this.products.map((x) => x.id!));
        break;
      case SelectionType.SelectAll:
        this.selectAllProducts();
        break;
      case SelectionType.Deselect:
        this.clearSelected();
        break;
      default:
        break;
    }

    this.selectionChange.emit(this.setOfSelectedProducts);
  }
  selectAllProducts() {

    this.isLoading = true;
    const payload: ListPayload = {
      Filters: this.payload.Filters,
      IsAscend: true,
      PageIndex: 0,
      PageSize: 0,
      SortBy: 'Id',
    };
    this.subscriptions.push(
      this.productService
        .selectAllProducts(payload)
        .pipe(
          tap((response) => {

            this.setOfSelectedProducts = new Set(response as any[]);
            this.selectedIds = new Set();
            this.setOfSelectedProducts.forEach((element) => {
              this.selectedIds.add(element.id!);
            });
            this.selectedIds = new Set(response);
            if (this.setOfSelectedProducts.size > 0) {
              this.selectionChange.emit(this.setOfSelectedProducts);
            }
            this.isLoading = false;
          })
        )
        .subscribe()
    );
  }
  
  
selectAll() {
  this.channelsService.getAllChannelsProducts(this.payload,this.channelId,this.integrationId).subscribe({
    next: (data) => {
      this.selectedIds = new Set<number>(data);
    if(  this.selectedIds.size>0){
    this.setOfSelectedProducts = new Set(data as Product[]);
    this.selectionChange.emit(this.setOfSelectedProducts);  
    }
    
  this.selectedIds = new Set<number>(
  (data as number[]).filter(id => id !== undefined && id !== null)
);
    },
    error: (err) => {

    }
  });
}


  onItemChecked(product: Product, status: boolean) {
    if (status === true) {
      this.setOfSelectedProducts.add(product);
      this.selectedIds.add(product.id!);
      // this.
    } else {
      this.selectedIds.delete(product.id!);
      this.setOfSelectedProducts.delete(product);
    }
    this.selectionChange.emit(this.setOfSelectedProducts);
    if (
      this.selectedIds.size > 0 &&
      this.selectedIds.size != this.products.length
    )
      this.selectorObject.headerIndeterminate = true;
    else if (this.selectedIds.size == 0)
      this.selectorObject.headerIndeterminate = false;
    else {
      this.selectorObject.headerIndeterminate = false;
      this.selectorObject.headerChecked = true;
    }
  }
  //#endregion

  startBulkEditRequest() {
    const ids = Array.from(this.selectedIds);
    this.connectionService.create(
      `${AppConfigService.settings.baseUrl}data-api/BulkEditRequest`,
      {
        ObjectType: 12,
        ObjectTypeName: 'product',
        ObjectIds: ids.join(','),
      } as any,
      (record) => {
        this.router.navigate(['/bulk-edit', record.Id], {
          queryParams: { customBack: true, entityType: 'product' },
        });
      }
    );
  }
  onPageIndexChange(pageIndex: number) {
    this.payload.PageIndex = pageIndex - 1;
    this.getProducts.emit(this.payload);
  }

  showSyncModal() {
    this.showSync = true;
  }
  selectedChannelsChanged(channels: Set<Channel>) {
    this.setOfSelectedChannels = channels;
  }
  submitChannels() {
    const data: ChannelMappingData[] = [];
    Array.from(this.selectedIds).forEach((prod) => {
      Array.from(this.setOfSelectedChannels).forEach((channel) => {
        data.push({
          ChannelId: channel.ChannelId,
          IntegrationId: channel.IntegrationId,
          ObjectId: prod,
          ObjectType: 12,
          Processed: false,
          Selected: true,
        });
      });
    });
    this.channelsService.syncProducts(data).subscribe(() => {
      this.showSync = false;
      this.message.success('Products posted successfully.');
    });
  }
  cancelSync() {
    this.setOfSelectedChannels.clear();
    this.showSync = false;
  }

  deleteProduct(id: number) {
    const product = this.products.find((x) => x.id == id);
    this.productService
      .deleteProduct(id)
      .pipe(
        tap(() => {
          this.notification.info(
            `Product delete`,
            `Product [${product.sku}] delete successfully`
          );
          this.getProducts.emit();
        })
      )
      .subscribe();
  }
  onSingleSelection(product: Product) {
    this.setOfSelectedProducts.add(product);
    this.selectedIds.add(product.id!);
    const drawerRef = this.injector.get(NzDrawerRef);
    if (drawerRef != null) {
      drawerRef.close();
    }
  }

  exportProducts() {

    const selectedIds = new Set<number>();
    if (this.checked && !this.indeterminate) {
      this.setOfSelectedProducts.forEach((element: any) => {
        if (typeof element === 'number') {
          selectedIds.add(element);
        }
      });
    } else {
      this.setOfSelectedProducts.forEach((element) => {

        selectedIds.add(element.id!);
      });
    }



    this.loading = true;
    this.productService
      .exportProducts(Array.from(selectedIds))
      .subscribe(() => {
        this.loading = false;
      });
  }



  getSelectedCount(): number {
    return this.selectedIds.size;
  }


  isString(value: unknown): value is string {
    return typeof value === 'string';
  }



}



